import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import Home from './views/Home/Home';
import Create from './views/Create/Create';
import Overview from './views/Overview/Overview'

function App() {
  return (
    <div className="App">
     <Router>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/create">
            <Create />
          </Route>

          {/* Get the id of the poll */}
          <Route path="/overview/:id">
            <Overview />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
